import React from 'react'
import { useTranslation } from 'react-i18next'
import { MetaTitle } from '../../Components/UI'
import { withRouter, Link } from 'react-router-dom'
import { Result, Card, Typography, Button } from 'antd'
import { style } from './style'

const { Text } = Typography

const RequestConfirmation: React.FC = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <MetaTitle title={t('RequestConfirmation.metaTitle', 'Confirmation - HeadBox')} />
      <Card style={style.card}>
        <Result
          status='success'
          title={
            <Text strong style={style.title}>
              {t('RequestConfirmation.title', "You've requested to book!")}
            </Text>
          }
          subTitle={t(
            'RequestConfirmation.subTitle',
            'We will be in touch within 24 hours to provide the contract and confirm the booking.'
          )}
          extra={
            <Link to='/'>
              <Button type='primary'>{t('RequestConfirmation.goToEvents', 'Back to Home')}</Button>
            </Link>
          }
        />
      </Card>
    </>
  )
}

export default withRouter(RequestConfirmation)
